import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import EditPostPropertyForm from "../../../../components/pages/profile/EditPostPropertyForm";
import { getPropertiesById, updateProperty } from "../../../../services/propertyService";
import { usePropertyForm } from "../../../../hooks/pages/property/usePropertyForm";
import { parsePropertyImages } from "../../../../utils/admin/parsePropertyImages";

export default function EditProperty() {
  const { id } = useParams();
  const navigate = useNavigate();

  const {
    formData,
    setFormData,
    setExistingImages,
    ...formProps
  } = usePropertyForm(
    (data) => updateProperty(id, data),
    "/my-properties"
  );

  useEffect(() => {
    const fetchProperty = async () => {
      try {
        const property = await getPropertiesById(id);
        setFormData(property);
        setExistingImages(parsePropertyImages(property.images));
      } catch (err) {
        console.error("Lỗi khi tải thông tin bất động sản:", err);
        toast.error("Không tìm thấy bất động sản.");
        navigate("/my-properties");
      }
    };

    fetchProperty();
  }, [id, navigate, setFormData, setExistingImages]);

  if (!formData) return <p>Đang tải dữ liệu bất động sản...</p>;

  return (
    <EditPostPropertyForm
      formData={formData}
      setFormData={setFormData}
      {...formProps}
    />
  );
}